import React from 'react';
import { Redirect } from 'react-router-dom';

const OauthLoginRedirectionComponent = () => <Redirect to="/onboarding/login" />;

export default OauthLoginRedirectionComponent;
